import { render, staticRenderFns } from "./AudioRoom.vue?vue&type=template&id=0a4762a6&scoped=true&"
import script from "./AudioRoom.vue?vue&type=script&lang=js&"
export * from "./AudioRoom.vue?vue&type=script&lang=js&"
import style0 from "./AudioRoom.vue?vue&type=style&index=0&id=0a4762a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4762a6",
  null
  
)

export default component.exports